import React from "react";

// todo: take in unique routing w/ user check to see if they cacn view the page
// todo: write design on what it needs to look like
// todo: find source of viewers
const CompanyAnalyticsPage = () => {


    return(<div>CompanyAnalyticsPage</div>)
}

export default CompanyAnalyticsPage;